//import axios from "axios";
//import { httpClient } from "./HttpClient";
import { config } from "../constants";
import axios from 'axios';

const jwt = require("jsonwebtoken");
const moment = require("moment");

class CallApi {

  async setSysToken() {
    let resp = await axios.post(config.apiUrl + "/login/gtkn", {});
    // console.log(resp.data);
    return resp.data;
  }

  async refreshToken() {
    //const refresh_token = localStorage.getItem("refresh_token");
    const data = {
      refresh_token: localStorage.getItem("refresh_token")
    };
    var formBody = [];
    for (var property in data) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(data[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    return await fetch(config.apiUrl + "/trueid/refreshtoken", {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        //"Content-Type": "application/x-www-form-urlencoded"
        // "X-Custom-Header": (localStorage.getItem("sys_token") || '')
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(response => response.json())
      .then(result => {
        // console.log(result);
        if (result.access_token) {
          const expires_at = moment().add(result.expires_in - 600, "s").format();
          // localStorage.setItem("access_token", result.access_token);
          // localStorage.setItem("expires_in", result.expires_in);
          // localStorage.setItem("refresh_token", result.refresh_token);
          // localStorage.setItem("expires_at", expires_at);

          const userData = jwt.decode(result.access_token);
          const getProfileBody = { ssoid: userData.sub, token: result.access_token };
          fetch(config.apiUrl + "/trueid/profile", {
            method: "POST",
            mode: "cors", // no-cors, cors, *same-origin
            cache: "no-cache",
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Headers": "Origin, X-Requested-With",
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            body: JSON.stringify(getProfileBody)
          })
            .then(response => response.json())
            .then(profile => {

              if (parseInt(profile.code) === 200) {

                localStorage.setItem("access_token", result.access_token);
                localStorage.setItem("user_login", profile.login_account);
                localStorage.setItem("expires_in", result.expires_in);
                localStorage.setItem("refresh_token", result.refresh_token);
                localStorage.setItem("expires_at", expires_at);

              } else {
                console.error("Error 3 :", profile);
                // localStorage.setItem("access_token", result.access_token);
                localStorage.setItem("user_login", '');
                // localStorage.setItem("expires_in", result.expires_in);
                // localStorage.setItem("refresh_token", result.refresh_token);
                // localStorage.setItem("expires_at", expires_at);
              }
            })
            .catch(error2 => {
              console.error("Error 2 :", error2);
              // localStorage.setItem("access_token", result.access_token);
              localStorage.setItem("user_login", '');
              // localStorage.setItem("expires_in", result.expires_in);
              // localStorage.setItem("refresh_token", result.refresh_token);
              // localStorage.setItem("expires_at", expires_at);
            });
        } else {
          console.error("Error 4:", result);
        }
      })
      .catch(error => {
        console.error("Error:", error);
        // alert(msg.errMessage);
      });
  }

  async postWithOutToken(url, data = {}) {
    const call_url = config.apiUrl + url;
    console.log('CallApi>postWithOutToken ' + call_url);

    return fetch(call_url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        // "X-Custom-Header": (localStorage.getItem("sys_token") || '')
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(response => response.json())
      .catch(error => console.error("Error:", error)); // parses JSON response into native Javascript objects
  }

  async patch(url, data = {}) {
    console.log('CallApi>patch ' + url);
    const expires_at = localStorage.getItem("expires_at");
    //console.log(moment().toString());
    if (moment().isSameOrAfter(expires_at)) {
      await this.refreshToken();
    }

    // var formBody = [];
    // for (var property in data) {
    //   var encodedKey = encodeURIComponent(property);
    //   var encodedValue = encodeURIComponent(data[property]);
    //   formBody.push(encodedKey + "=" + encodedValue);
    // }
    // formBody = formBody.join("&");
    //console.log(formBody);

    const call_url = config.apiUrl + url;
    //console.log(call_url);
    const jwtToken = localStorage.getItem("access_token");
    return fetch(call_url, {
      method: "PATCH", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        //"Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + jwtToken,
        // "X-Custom-Header": (localStorage.getItem("sys_token") || '')
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(response => response.json())
      .catch(error => console.error("Error:", error)); // parses JSON response into native Javascript objects
  }

  async patchSecurity(url, data = {}) {
    console.log('CallApi>patchSecurity ' + url);
    const expires_at = localStorage.getItem("expires_at");
    //console.log(moment().toString());
    if (moment().isSameOrAfter(expires_at)) {
      await this.refreshToken();
    }

    // var formBody = [];
    // for (var property in data) {
    //   var encodedKey = encodeURIComponent(property);
    //   var encodedValue = encodeURIComponent(data[property]);
    //   formBody.push(encodedKey + "=" + encodedValue);
    // }
    // formBody = formBody.join("&");
    //console.log(formBody);

    const call_url = config.apiUrlS + url;
    //console.log(call_url);
    const jwtToken = localStorage.getItem("access_token");
    return fetch(call_url, {
      method: "PATCH", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        //"Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + jwtToken,
        // "X-Custom-Header": (localStorage.getItem("sys_token") || '')
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(response => response.json())
      .catch(error => console.error("Error:", error)); // parses JSON response into native Javascript objects
  }

  async postSecurity(url, data = {}) {
    console.log('CallApi>postSecurity ' + url);
    const expires_at = localStorage.getItem("expires_at");
    //console.log(moment().toString());
    if (moment().isSameOrAfter(expires_at)) {
      await this.refreshToken();
    }

    var formBody = [];
    for (var property in data) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(data[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    //console.log(formBody);

    const call_url = config.apiUrlS + url;
    //console.log(call_url);
    const jwtToken = localStorage.getItem("access_token");
    return fetch(call_url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        //"Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + jwtToken,
        // "X-Custom-Header": (localStorage.getItem("sys_token") || '')
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(response => response.json())
      .catch(error => console.error("Error:", error)); // parses JSON response into native Javascript objects
  }

  async post(url, data = {}) {
    console.log('CallApi>post ' + url);
    const expires_at = localStorage.getItem("expires_at");

    if (moment().isSameOrAfter(expires_at)) {
      await this.refreshToken();
    }

    var formBody = [];
    for (var property in data) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(data[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    //console.log(formBody);

    const call_url = config.apiUrl + url;
    //console.log(call_url);
    const jwtToken = localStorage.getItem("access_token");
    return fetch(call_url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        //"Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + jwtToken,
        // "X-Custom-Header": (localStorage.getItem("sys_token") || '')
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(response => response.json())
      .catch(error => console.error("Error:", error)); // parses JSON response into native Javascript objects
  }

  async get(url) {
    console.log('CallApi>get ' + url);
    const expires_at = localStorage.getItem("expires_at");

    if (moment().isSameOrAfter(expires_at)) {
      await this.refreshToken();
    }
    const jwtToken = localStorage.getItem("access_token");
    return fetch(config.apiUrl + url, {
      // method: "GET", // *GET, POST, PUT, DELETE, etc.
      method: "POST",
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        //"Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + jwtToken,
        // "X-Custom-Header": (localStorage.getItem("sys_token") || '')
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer" // no-referrer, *client
      //body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(res => res.json())
      .catch(error => console.error("Error:", error));
  }

  async getSecurity(url) {
    console.log('CallApi>getSecurity ' + url);
    const expires_at = localStorage.getItem("expires_at");
    if (moment().isSameOrAfter(expires_at)) {
      await this.refreshToken();
    }
    const jwtToken = localStorage.getItem("access_token");
    return fetch(config.apiUrlS + url, {
      // method: "GET", // *GET, POST, PUT, DELETE, etc.
      method: "POST",
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        //"Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + jwtToken,
        // "X-Custom-Header": (localStorage.getItem("sys_token") || '')
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer" // no-referrer, *client
      //body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(res => res.json())
      .catch(error => console.error("Error:", error));
  }

  async delete(url, data = {}) {
    console.log('CallApi>delete ' + url);
    const expires_at = localStorage.getItem("expires_at");
    //console.log(moment().toString());
    if (moment().isSameOrAfter(expires_at)) {
      await this.refreshToken();
    }

    const call_url = config.apiUrl + url;
    //console.log(call_url);
    const jwtToken = localStorage.getItem("access_token");
    return fetch(call_url, {
      method: "DELETE", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        //"Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + jwtToken,
        // "X-Custom-Header": (localStorage.getItem("sys_token") || '')
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(response => response.json())
      .catch(error => console.error("Error:", error)); // parses JSON response into native Javascript objects
  }

  async deleteSecurity(url, data = {}) {
    console.log('CallApi>deleteSecurity ' + url);
    const expires_at = localStorage.getItem("expires_at");
    //console.log(moment().toString());
    if (moment().isSameOrAfter(expires_at)) {
      await this.refreshToken();
    }

    const call_url = config.apiUrlS + url;
    //console.log(call_url);
    const jwtToken = localStorage.getItem("access_token");
    return fetch(call_url, {
      method: "DELETE", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        //"Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + jwtToken,
        // "X-Custom-Header": (localStorage.getItem("sys_token") || '')
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then(response => response.json())
      .catch(error => console.error("Error:", error)); // parses JSON response into native Javascript objects
  }
}

export default CallApi;
